<template>
    <picnic-modal title="Error" ref="modal">
        {{ message }}

        <span slot="buttons">
            <v-button @click="$refs.modal.hide()" class="dangerous">
                Close
            </v-button>
        </span>
    </picnic-modal>
</template>

<script>
    import PicnicModal from './PicnicModal.vue'

    export default {
        data () {
            return {
                message: ''
            }
        },
        components: {
            'picnic-modal': PicnicModal
        },
        methods: {
            alert (msg) {
                this.message = msg
                this.$refs.modal.show()
            }
        }
    }
</script>